document.addEventListener('DOMContentLoaded', function () {
  initVariantImageSwitcher();
});

document.addEventListener('shopify:section:load', function () {
  initVariantImageSwitcher();
});

function initVariantImageSwitcher() {
  document.querySelectorAll('input[type="radio"][name^="options[Boja]"], input[type="radio"][name^="options[boja]"]').forEach(function (input) {
    input.addEventListener('change', function () {
      const selectedValue = this.value;
      const match = window.location.pathname.match(/\/products\/([^\/]+)/);
      if (!match) return;
      const productHandle = match[1];

      fetch('/products/' + productHandle + '.js')
        .then(r => r.json())
        .then(product => {
          const variant = product.variants.find(v =>
            v.options.some(o => o.toLowerCase() === selectedValue.toLowerCase())
          );
          if (variant && variant.featured_image) {
            const imgUrl = variant.featured_image.src.split('?')[0];
            updateMainImage(imgUrl);
          }
        });
    });
  });
}

function updateMainImage(imgUrl) {
  const selectors = [
    '.product__media img',
    '.product-single__photo img',
    '.product__photo img',
    '[data-product-featured-image]',
    '.featured-image img'
  ];

  for (const selector of selectors) {
    const img = document.querySelector(selector);
    if (img) {
      img.src = imgUrl;
      img.srcset = '';
      break;
    }
  }
}